import axios from 'axios';

export const axiosClassic = axios.create({
  baseURL: '/api',
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
